<template>
  <section class="event-item">
    <header class="event-item__header">
      <div class="event-item__datetime">
        <div class="event-item__time">
          {{ time }}
        </div>
        <div v-if="item.start && item.date" class="event-item__date">
          {{ item.date }}
        </div>
      </div>
      <div class="event-item__location">
        <icon class="event-item__icon" name="location" width="10" height="10" />
        {{ item.location }}
      </div>
    </header>
    <figure class="event-item__picture">
      <img class="event-item__image" :src="item.image" :srcset="`${item.image2x} 2x`">
    </figure>
    <div class="event-item__content">
      <h3 class="event-item__title">{{ item.title }}</h3>
      <div class="event-item__subtitle" v-html="item.content"></div>
    </div>
  </section>
</template>

<script>
import Icon from '../shared/Icon'

export default {
  components: {
    Icon
  },
  props: {
    item: Object
  },
  computed: {
    time () {
      if (!this.item.start) return this.item.date
      return this.item.start + (this.item.end ? `—${this.item.end}` : '')
    }
  }
}
</script>

<style lang="scss" scoped>
.event-item {
  background: $white;
  box-shadow: 0 0 14px 0 rgba(0, 0, 0, 0.12);
  height: 100%;
  padding: 20px 0;
  max-width: 295px;
  margin: 0 auto;

  &__header,
  &__content {
    padding-left: 15px;
    padding-right: 15px;
  }

  &__header {
    @include font-size($font-size-sm);
    text-transform: uppercase;
  }

  &__datetime {
    align-items: center;
    display: flex;
    margin-bottom: 10px;
  }

  &__time {
    background: $theme-red-100;
    color: $white;
    padding: 2px 7px;
  }

  &__date {
    color: $theme-gray-700;
    margin-left: 12px;
  }

  &__icon {
    margin-right: 5px;
  }

  &__picture {
    margin: 15px 0;
  }

  &__image {
    @include img-fluid;
  }

  &__title {
    @include font-size($font-size-lg);
    font-weight: normal;
    line-height: 1.3;
    margin-bottom: 20px;
  }

  &__subtitle {
    color: $theme-gray-700;
  }
}
</style>
